import { cn } from "@/util/cn";

type H1Props = {
  className?: string;
  children: React.ReactNode;
};

export default function H1({ className, children }: H1Props) {
  return (
    <h1
      className={cn(
        "text-3xl font-sans leading-none tracking-tight font-normal",
        // "font-semibold text-2xl tracking-tight",
        className
      )}
    >
      {children}
    </h1>
  );
}
